// extracted by mini-css-extract-plugin
export default {"modal":"EstudianteAdeudo_modal__LfKTY","botok":"EstudianteAdeudo_botok__WfeEI","botCancela":"EstudianteAdeudo_botCancela__EHZc+"};